import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLang } from "../../context/LangContext";
import { useCategories } from "../../api/useApi";

const ShopProduct = ({ products, addToCartProduct, isLoading, error }) => {
  const { t } = useTranslation();
  const { lang } = useLang();
  const [startIndex, setStartIndex] = useState(0);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const productsPerPage = 6;
  const scrollBy = 1;

  const { data: categories, isLoading: loadingCategories } = useCategories();

  const filteredProducts = selectedCategory
    ? (products || []).filter(
        (product) => product.category?._id === selectedCategory
      )
    : products || [];

  const nextProducts = () => {
    if (startIndex + scrollBy < filteredProducts.length - productsPerPage) {
      setStartIndex(startIndex + scrollBy);
    }
  };

  const prevProducts = () => {
    if (startIndex - scrollBy >= 0) {
      setStartIndex(startIndex - scrollBy);
    }
  };

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
    setStartIndex(0); // Reset pagination when category changes
  };

  return (
    <section className="wpo-shop-section section-padding">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-7 col-12">
            <div className="section-title">
              <h2 className="main-title">{t(`ourServices`)}</h2>
              <h3 className="title">{t(`ourServicesSubTitle`)}</h3>
            </div>
          </div>
        </div>
        <div className="service-wrap">
          {/* Category Filter */}
          <div className="row">
            {/* Category Buttons */}
            {!loadingCategories &&
              categories?.map((category, index) => (
                <div
                  className="col-xl-4 col-lg-6 col-md-6 col-12"
                  key={category._id}
                >
                  <div
                    className="service-card"
                    role="button"
                    onClick={() => handleCategoryChange(category._id)}
                    style={{
                      backgroundColor:
                        selectedCategory === category._id
                          ? "#f1f1f1"
                          : "transparent",
                      border: "none",
                    }}
                  >
                    <div className="top-number">
                      <span>{index + 1}</span>
                    </div>
                    <div className="icon">
                      <img src={category.icon} alt="service" />
                    </div>
                    <div className="text">
                      <h2 className="main-title">
                        {lang === "ar" ? category.name?.ar : category.name?.en}
                      </h2>
                      <p>
                        {lang === "ar"
                          ? category.description?.ar
                          : category.description?.en}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
          </div>

          <div className="section-title">
            <h2 className="main-title">{t(`ourProducts`)}</h2>
            <h3 className="title">{t(`ourProductsSubTitle`)}</h3>
          </div>

          <div className="col col-xs-12">
            <div className="shop-grids clearfix">
              {isLoading ? (
                t(`loading`)
              ) : filteredProducts.length > 0 ? (
                filteredProducts
                  .slice(startIndex, startIndex + productsPerPage)
                  ?.map((product, index) => (
                    <div className="grid" key={index}>
                      <Link
                        className="img-holder"
                        onClick={() => window.scrollTo(10, 0)}
                        to={`/product-single/${product.slug}`}
                      >
                        <img src={product?.proImg} alt={product?.title} />
                      </Link>
                      <div className="details">
                        <h3 className="title">
                          <Link
                            onClick={() => window.scrollTo(10, 0)}
                            to={`/product-single/${product.slug}`}
                          >
                            {product.title}
                          </Link>
                        </h3>
                        <span>
                          {product.price} {t("currency")}
                        </span>
                        <div className="add-to-cart">
                          <button
                            data-bs-toggle="tooltip"
                            data-bs-html="true"
                            title={t(`addToCart`)}
                            onClick={() => addToCartProduct(product)}
                          >
                            {t(`addToCart`)}
                          </button>
                        </div>
                      </div>
                    </div>
                  ))
              ) : error ? (
                <div className="error-message">
                  {error.message ||
                    "An error occurred while fetching products."}
                </div>
              ) : (
                "No Products Found"
              )}
            </div>
            <div className="pagination-wrapper pagination-wrapper-center">
              <ul className="pg-pagination">
                <li>
                  <Link
                    onClick={prevProducts}
                    disabled={startIndex === 0}
                    aria-label="Previous"
                  >
                    <i className="ti-angle-left"></i>
                  </Link>
                </li>
                {Array.from(
                  {
                    length: Math.ceil(
                      filteredProducts.length / productsPerPage
                    ),
                  },
                  (_, index) => (
                    <li
                      key={index}
                      className={index === startIndex ? "active" : ""}
                    >
                      <Link
                        onClick={() => setStartIndex(index * productsPerPage)}
                      >
                        {index + 1}
                      </Link>
                    </li>
                  )
                )}
                <li>
                  <Link onClick={nextProducts} aria-label="Next">
                    <i className="ti-angle-right"></i>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ShopProduct;
